<template>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="16" :fill="`url(#${gradientId})`" />
        <path
            d="M20.1111 8C23.6333 8 26 11.3525 26 14.48C26 20.8138 16.1778 26 16 26C15.8222 26 6 20.8138 6 14.48C6 11.3525 8.36667 8 11.8889 8C13.9111 8 15.5 10 16 11.9237C16.5 10 18.0889 8 20.1111 8Z"
            fill="#DB6C61"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <defs>
            <linearGradient :id="gradientId" x1="0" y1="0" x2="10.3372" y2="38.7448" gradientUnits="userSpaceOnUse">
                <stop offset="0.0001" stop-color="#FFE9E9" />
                <stop offset="0.102246" stop-color="#FFDEE6" />
                <stop offset="0.965" stop-color="#FFF8D5" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'IconLikeOn',

    //Фикс для Safari
    computed: {
        gradientId() {
            return `heart-gradient-${Math.random().toString(36).slice(2)}`;
        },
    },
};
</script>
